
import Vue from 'vue'

const captchaKeys = {
  fightKey: '6LdV3DcUAAAAAAALV6qKegvlKZ64e8ZPJqg_inqG',
  testKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
}

const getKey = (env) => {
  let key = ''
  switch (env) {
    case 'development':
      key = captchaKeys.testKey
      break
    case 'production':
      key = captchaKeys.fightKey
      break
    case 'game':
      key = captchaKeys.fightKey
      break
    case 'customTest':
      key = captchaKeys.testKey
      break
    default:
      key = captchaKeys.fightKey
  }
  // console.log('getKey', { env, key })
  return key
}

const CaptchaConfigurator = {
  install (Vue) {
    const env = process.env.NODE_ENV
    const captchaKey = getKey(env)
    Vue.getCaptchaKey = function () {
      return captchaKey
    }
  }
}

Vue.use(CaptchaConfigurator)
// export default CaptchaConfigurator
